import React, { useEffect, useState } from "react";
import BackButton from "../../components/Form/BackButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MyProfile from "./MyProfile";
import ChangePassword from "./components/ChangePassword";
import SubscriptionAfterLogin from "./components/SubscriptionAfterLogin";
import InvitationTab from "./invitations/InvitationTab";

const tabsKey = {
  "my-profile": 1,
  "change-password": 2,
  subscriptions: 3,
  invitations: 4,
};

const UserSetting = () => {
  const location = useLocation();
  // const role = localStorage.getItem("role");
  const roleType = localStorage.getItem("roleType");
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "my-profile";
  const defaultActiveKey = tabsKey[selectedTab.replace(/\?.*/, "")];
  const [activeTab, setActiveTab] = useState(
    parseInt(defaultActiveKey) === 4
      ? "invitations"
      : parseInt(defaultActiveKey) === 3
      ? "subscriptions"
      : parseInt(defaultActiveKey) === 2
      ? "change-password"
      : "my-profile"
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab !== "invitations") {
      navigate(`/user-settings?tab=${activeTab}`, {
        replace: true,
      });
    }
  }, [activeTab, navigate]);

  return (
    <>
      <div className="cms-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <h1 className="page-title">
              <BackButton />
              {activeTab === "change-password"
                ? "Change Password"
                : activeTab === "subscriptions"
                ? "Subscriptions"
                : activeTab === "invitations"
                ? "Invitations"
                : "My Profile"}
            </h1>
            <div className="content-details">
              {/* {activeTab === "invitations-from-builder" && <Workinprogrees />} */}
              <div className="table-top-btn">
                <ul
                  className="nav nav-tabs"
                  onClick={(event) => {
                    setActiveTab(
                      event?.target?.innerText.replace(/ /g, "-").toLowerCase()
                    );
                  }}
                >
                  <li className={activeTab === "my-profile" ? "active" : ""}>
                    <Link key={1}>My Profile</Link>
                  </li>
                  <li
                    className={activeTab === "change-password" ? "active" : ""}
                  >
                    <Link key={2}>Change Password</Link>
                  </li>
                  {roleType !== "Admin" && (
                    <li className={activeTab === "invitations" ? "active" : ""}>
                      <Link key={3}>Invitations</Link>
                    </li>
                  )}
                </ul>
              </div>
              <div className="custom-table tab-table">
                {activeTab === "my-profile" && <MyProfile />}
                {activeTab === "change-password" && <ChangePassword />}
                {activeTab === "subscriptions" && <SubscriptionAfterLogin />}
                {activeTab === "invitations" && roleType !== "Admin" && (
                  <InvitationTab />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSetting;
